import cover from "../../assets/pic1.png";
export const source = () => {
  const result = [
    {
      title: "kan qopheesse",
      details: {
        html: `
        <h4>kan qopheesse</h4>
        <ol>
        <li>.Dr. Mangistuu Gabrayohannis, Ispeeshaalistii Lafee fi Walqaba Qaamaa;
        Hakiima Sab-ispeeshaalistii Lafee Dugdaa</li>
        <li>Dr. Efireem Gabrahaanna, Ispeeshaalistii Lafee fi Walqaba Qaamaa;;
        Hakiima Sab-ispeeshaalitii Balaawwaan Hamaa fi Jijjiirraa Walqaba
        Qaamaa</li>
      </ol>
      <div style="padding-left: 30%;">
      <p>Hawaasaa Itiyoophiyaa<br> 2016 G.C</p>
      </div>
      <table>
  <tr>
    <th>Misooma application</th>
    <th>Ispoonsara kan ta'an</th>
    </tr>
    <tr>
    <td>Ermiyaas Kurabaachoo <br>+251 92 250 0469</td>
    <td>Gamtaa AO</td>
    </tr>
    </table>

    `,
      },
      image: "bosad_poster",
    },
    {
      title: "Mirga garagalchuu",
      details: {
        html: `
        <h3>Mirgi Qopheessitootaa Seeraan Kan Eegame, Bara 2016</h3>
      <h4>© All rights reserved 2023 G.c</h4>
      <p style="padding-right: 10px;">
        Itoophiyaatti maxxanfame</p>
        <p>
        Labsii Eegumsa Mirgoota Mirga Waraabbii Waliin Walqabatan labsii lakk 410/1996 labsii lakk 872/2007 tti akkaataa fooyya’een hayyamameen alatti,Kutaan maxxansa kanaa kamiyyuu, guutummaatti yookiin gartokkoon,bifa kamiinuu baay’ifamuu yookiin raabsamuu, yookiin kuusaa deetaa(kuusaa odeeffannoo) keessatti kuufamuu yookiin itti fayyadamuun hin danda’amu. Qorannoon kun kan Itoophiyaatti argamu garee qorannoo BOSAD yoo ta’u, hayyama barreeffamaa malee guutummaatti ykn gartokkoon isaa baay’isuun hin danda’amu.
      </p>
      <p style="padding-right: 10px;">
      Qorannoon kun tooftaalee ittisaa fi wal’aansa hospitaala duraa akka tasaa kufaatii daa’imman barnoota irra jiranii garee qorannoo BOSAD bakka bu’uun kan qophaa’e yommuu ta’u, odeeffannoowwanis kan qindaa’an gabaasuma qorannoo sadarkaa biyyooleessa kanarraayi.
      </p>
      <p style="padding-right: 10px;">
      Fakkii Fuullee fi Diizaayina: Das Adiveertizingii 
      Kan hiike:Salamoon Alamuu      
      </p>
      <p>
      Yaada kennuu yoo barbaaddan teessoo itti aanu kana fayyadamaa:
      Dr. Mangistuu Gebreyohaannis, Lakka. Bilbilaa: 0910120423 yookaan E-meeli: mengistugmengesha@gmail.com      
      </p>`,
      },
    },
    {
      title: "Galata",
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
        Garee qorannoo “BOSAD” fi ogeeyyii afaanii afaan adda addaatti hiikuun akka danda’amu taasisaniif Galanni guddaan isaaniif mala. Dr. Hisqiyaas Kasayee, Dr.Araya Tilahun, Dr.Tolasaa Dinsa fi Aadde Eden Alemu (Qindeessituu Qorannoo BOSAD) sanada kana fooyyessuu keessatti gumaacha gatii guddaa qabu taasisaniif. Gumaacha keessaniif beekamtii addaa ni kennina.
      </p>
      <ol>
        <li>
        Dr. Mangistuu G/Yohaannis- Ispeeshaalistii Lafee fi Walqaba Qaamaa; Hakiima Sab-ispeeshaalistii Lafee Dugdaa
        </li>
        <li>
        Dr. Efireem G/Haannaa- Ispeeshaalistii Lafee fi Walqaba Qaamaa; Hakiima Sab-ispeeshaalitii Balaawwaan Hamaa fi Jijjiirraa Walqaba Qaamaa
        </li>
      </ol>
      </div>
      `,
      },
    },
    {
      title: `Seensa`,
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
        Balaa kufaatii tasa mana barnootaatti ijoollee muudatu, tarsiimoo ittisaa isaa fi wal’aansa hoospitaala gahuun dura taasifamu irraatti xiyyeeffatee barreeffamni barnoota kennu kan sadarkaa kanatti qophaa’e waan hinjirreef, ijoolleen yeroo miidhaman ni mul’ata. Kanaafuu barruuleen kun afaanota garaa garaatin kan qophaa’eef qaawwa jiru kana yaada keessa galchuun rakkoo mul’atu kana furuufi. Barruuleen kun kan qophaa’e garee ogeeyyii Itoophiyaa fi Gaambiyaa keessatti sadarkaa biyyoolessaatti qorannoo “BOne Setting Associated Disability (BOSAD)” jedhamu adeemsisaa jiru. Kaayyoon qorannichaa miidhaan lafee fi walqaba qaamaa (musculoskeletal injury) yeroo ijoollee muudatu, huccuun jabeessanii maruun, leemmanaan hidhuu fi irra deddeebi’anii sukkuumuun kan ka’e, rakkoolee fayyaa walxaxaa uumaman ittisuudha. Kaayyoon waliigalaa garee qo’annoo BOSAD, biyyattii keessatti wal’aansa gama hundaan miidhaa lafee fi wal’qaba qaamaaf kennamu fooyyessuudha.
        </p>
        <p style="padding-right: 10px;">
        Qorannoon kun waggaa tokkoo fi walakkaa darbe keessa wayita adeemsisamaa turetti, ijoolleen mana barnootaa keessatti kufanii miidhaan qaamaa irra gahe hedduu turan. Ijoolleen miidhaman kunis gara ogeessa aadaatti geessamanii kutaan qaamaa isaanii miidhame akka sukkuumameef, leemmanaan akka hidhameef akkasumas guyyaa 7 hanga guyyaa 14f mana akka turan taasifamuun isaanii beekameera. Sana booda maatiin isaanii miidhaan sun itti wayyaa’uurra irra caalaa itti hammaachaa akka jiru gaafa hubatan, qorannoo dabalataaf gara dhaabbilee fayyaatti geessaniiru. Qorannoo dhaabbilee fayyaatti taasifameenis kutaan qaama ijoollee miidhamee ture gara dhibee gaangiriinii (tortoruu qaamaa) wal’aanamee fayyuu hindandeenyetti jijjiiramee qaamni isaanii akka muramu ta’eera; yookaan immoo haala umrii guutuu qaama miidhamtoota isaan taasisuun naafataniiru. Haalli kun dhugaa hadhaawaa akka hakiima lafee fi walqaba qaamaatti guyyaa guyyaan nu quunnamuudha. Ijoolleen kun osoo akkuma kufanii miidhaan irra gaheen gara dhaabbata fayyaatti geessamanii wal’aansa barbaachisu argataniiru ta’ee, yeroo gabaabaa keessatti fayyuu danda’u ture. Kana qofa osoo hintaane fayyaa gaarii horatanii yeroo gabaabaatti gara barnoota isaaniitti deebi’uu ni danda’u ture.
        </p>
        <p style="padding-right: 10px;">
        Barruulee gabaabaa odeeffannoo kennu kana sababii guddaan nuti qopheessuu barbaanneefis, waa’ee rakkoo kana hubannoo uumuu fi miidhaa qaamaa sababa kufaatiin uumamu tarsiimmoo ittiin ittifamu agarsiisuufi. Yeroo tokko tokko miidhaa sababa kufaatiin uumamu guutumaan guututti ittisuun kan danda’amu ta’uu baatus, erga uumamee booda garuu ijoollee miidhaman sana irra miidhaan dabalataa akka hingeenye ittisuun ni danda’ama.Kanaafuu, haala ijoolleen ariitiin wayyaa’uu itti danda’an mijeessuuf wal’aansi sirriin kennamuufi qaba. Barruuleen kun kana malees, ijoolleen miidhaman hoospitaala gahuu isaanitin dura gargaarsa wal’aansaa garaa garaa taasifamuufi qaban kan ibsu yommuu ta’u, gargaarsa wal’aansaa kanneen barsiistonni, maatiin barattootaa fi barattoonni mataan isaanii dubbisuu, hubachuu fi yeroo balaan akkasii uumamu qabatamaan itti fayyadamuu danda’u.
        </p>
        <p style="padding-right: 10px;">
        Hundi keenya akkuma beeknu ijoolleen akka gaheessotaa osoo hintaane qaamni isaanii xobbeedha. Bilchinni qaamaa isaaniis ta’ee sammuun isaanii gaarii  fi yaraa madaaluuf dandeettiin isaanii kan hingabbanne waan ta’eef, hordoffii nama biraa gama barbaaduutiin sadarkaan irra jiran olaanaadha. Gochootaa fi amala yaaddessaa qabaniinis gaheessota irraa baay’ee adda isaan taasisa. Kanaaf jecha barruulee gabaabaa miidhaawwan qaamaa sababa kufaatin ijoollee muudatu irratti xiyyeeffate kana qopheessuun kan barbaachiseef.
        </p>
      </div>   `,
      },
    },
    {
      title: `Kaayyoo Barruulee Kanaa`,
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
        Kaayyoon barruulee kanaa inni guddaan ijoollee mana barnootaa keessatti kufanii miidhaaf saaxilaman haalota yaaddessaa isaan quunnamuu malan akkamitti ittisuun akka danda’amuu kan qophaa’edha. Keessumaayyuu hoospitaala geessuun dura gargaarsa wal’aansaa gochuufi qabnu ilaalchisee ijoollee barnoota irra jiraniif,maatiiwwaniif,barsiisotaaf,ogeeyyii miidiyaa mana barnootaa keessa hojjetaniif (fakkeenyaaf akka miinii miidiyaa) akkasumas walumaaga latti hawaasa hundaaf odeeffannoo kennuuf yaadameeti. Barruuleen kun afaanota garaa garaa Itoophiyaa keessa jiranitti hiikamee manneen barnootaaf yoo danda’ame immoo maatiiwwaniif kan raabsamu ta’a.
        </p>
      </div> `,
      },
    },
    {
      title: `Hiikkaawwan`,
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
          <b>Ijoollee:-</b> Barruulee kana keessatti jecha ‘ijoollee’ jedhu kan fayyadamne warra umriin isaanii waggaa 18 gadi ta’e ibsuufi. Walumaagalatti ijoolleen barnoota hanga kutaa 12ffaa barachaa jiran hundi ramaddii kana keessa galaniiru.
        </p>
        <p style="padding-right: 10px;">
          <b>Kufuu ykn Miidhaa Kufuun Uumamu:-</b> Qaamni namaa tasa gara lafaatti yookaan iddoo olka’aa ta’e irraa gara gadiitti dhundhulee bu’uun lafa dhahuu ta’ee, taatee nama sanarraan miidhaa gahuu danda’uudha.
        </p>
        <p style="padding-right: 10px;">
          <b>Miidhaa ykn Miidhama Qaamaa:-</b> Barruulee kana keessatti jechi miidhaa fi miidhama qaamaa jedhu akka jecha wal fakkaataatti kan fayyadamne yoo ta’u, hiikkaan isaas dhiibbaa osoo hinyaadamin qaama namarra gahuun miidhama qaamaa uumamu jechuudha.
        </p>
      </div>
          `,
      },
    },
    {
      title: `Waa’ee Balaa Kufaatii Ijoollee Barnoota irra Jiranii Mari’achuun Maaliif Barbaachise?`,
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>
          Akka gabaasa Dhaabbata Fayyaa Addunyaatti ijoollee umrii hanga waggaa 18 keessa jiran irraan miidhaa qaamaa, du’aa fi qaama miidhamtummaa umrii guutuu qaqqabsiisuun ka’umsawwan adda duree ta’an sadeen keessaa tokko balaa kufiiti ijoolleeti.
          </li>

          <li>
          Biyyoota hinguddatin hedduu keessatti miidhama umrii daa’imummaatti kutaalee wal’aansa balaa tasaa keessatti baay’inaan mul’atu yommuu ta’u, ka’umsawwan miidhaa qaamaa hunda keessaa %25-52 qooda qaba.
          </li>

          <li>
          Ijoolleen barnoota isaanii akka addaan kutan kanneen sababa gurguddoo ta’an keessaa tokko dhukkubaa fi qaamaa miidhamtummaa sababa kufiitiin umamuudha.
          </li>

          <li>
          Miidhaan qaamaa sababa kufiitin uumamu wal’aansa yeroo dheeraaf ciisanii akkasumas manaa deddeebi’anii kennamu kan barbaadu waan ta’eef, baasiiwwan hawaasummaa fi diinagdee olaanaa ta’e maatiiwwanii fi hawaasa waliigalaa irraan gahaa jira.
          </li>

          <li>
          Balaan kufiiti Yuunaayitid Isteet keessatti, du’a umrii daa’imummaatti sababa miidhama qaamaatin dhufu qaqqabsiisuun sadarkaa afraffaa qabatee dursaa jira. Haalli kun biyyaa keenyatti dacha sadiin kan caalu waan ta’eef, rakkinichi kanaa caalaa hammaataa ta’a.
          </li>
          
          <li>
          Itoophiyaa keessatti muuxannoo qabnuun, ijoolleen kufanii erga miidhamanii booda, rakkoolee fayyaa walxaxaaf saaxilamanii arguun waan baay’ee barameedha. Waggoota sadeen darban keessa Yuunivarsitii Hawaasaatti baqaqsanii hodhuun (oppiraasiiyoonin) qaama miidhame muruun hojiilee hojjetaman keessaa gara  dhibbantaa  17 kan ta’u kan ijoolleeti. Kun ta’uu kan danda’e, miidhaan qaamaa hammeenyi isaa giddugaleessa ta’e erga irra gaheen booda, mana keessatti huccuun jabeeffamee maramee turee qaamni gara tortoruutti (gaangiriinitti) erga jijjiiramee booda gara hoospitaalaa waan dhufaniifi.
          </li>
          
        </ol>
      </div>
          `,
      },
      image: 1,
    },
    {
      title: `Ijoolleen Mana Barnootaa Keessatti Maaliif Kufu?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>
        Kufuun adeemsa guddina ijoollee keessatti waanuma jiruudha. Deemsa baruu yaaluun, waan tokko yaabuun, utaaluunifi naannoo isaanii keessa oliifi gadi nanaanna’anii sonuun haaluma ijoolleen ittiin guddatani. Akka carraa ta’ee garuu kufiitin ijoollee hedduun kanneen miidhaa xiqqaa qaqqabsiisani. Ijoollee hedduun umrii ijoollummaatti yeroo baay’ee kan kufan ta’us, qaamni isaanii xiqqoo madaa’uun ala, miidhaan qaamaa hamaa ta’e yeroo isaanirra gahu hin mul’atu. Mana barnootaa keessatti iddoowwan ijoolleen kufanii akka miidhaman saaxiluu danda’an tokko tokko ni jiru. Isaan keessaa kanneen gurguddoon kan itti aanan kana:
        </p>
        <ol>
          <li>
          Ijoollee xixiqqoon tarii meeshaalee ijoollee kunuunsuuf jecha qophaa’an irraa, fakkeenyaaf, meeshaalee iddoo oolmaa daa’imanii jiranirraa akkasumas meeshaa daa’imman ittiin tarkaanfatan (baby walker) irraa kufuu danda’u
          </li>

          <li>Kuun meeshaalee bakka ijoolleen itti taphatan jiranirraa kufuu malu;</li>

          <li>Baaxii irraa kufuu</li>

          <li>Iddoo nama mucuceessuutti yookaan iddoo jiidhetti keessumaa tibba
            roobni jiru kufuu malu;
          </li>
          <li>Yeroo gamootti ol bahanii fi yeroo bu’an akkasumas fooddaa banaan
            utaalanii kufuu;
          </li>

          <li>Mana barnootaa keessatti iddoo ijaarsi jirutti kufuu;</li>

          <li>Mana barnootaa keessatti bo’oo lolaa fi boollawwan bishaanitti kufuu</li>

          <li>Sochiilee ispoortii fi bashannanaa jechuunis kubbaa miilaa, kubbaa
            saaphanaa fi kanneen biro;
          </li>

          <li>Mukarraa kufuu- fuduraalee buusuuf yookaan taphaaf jecha muka ko-
            ranii kufuu;
          </li>

          <li>
            Beeyiladoota kanneen akka fardaa fi harree yaabbatanii kufuu. Baadiyyaatti
            ijoolleen farda ykn harree gulufsiisuuf jecha kufanii erga miidhamanii booda
            yeroo dhufan ni mul’ata.
          </li>

          <li>
            Gitoota isaanitin sakaalamanii yookaan micciiramanii kufuun,
            keessumaayyuu naannoo koomeeti miidhamuun baay’inaan mul’ata
          </li>
          
        </ol>
      </div>
          `,
      },
      image: 2,
    },
    {
      title: `Miidhaan qaamaa sababa kufiitin uumamu dhiibbaawwan gadheen fidu maal fa’a?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>
          Dhiibbaawwan gadheen sababa kufuutin dhufu haalota garaa garaa irratti
          hundaa’u. Isaanis fakkeenyaaf, umrii daa’imichaa, bakki kufee sun hanga
          inni ol dheeratu yookaan humna ittiin lafa dhahe, ariitii balaan sun
          ittiin uumame, lafti daa’imichi irratti kufe sun haala isaa akkasumas
          amala miidhaa sanaa (qaamni madaa’ee dhiigni alatti dhangala’uu ykn
          miidhaa keessoo-kan hindhiigin) fa’a of keessaa qaba. Miidhaawwan kun
          qaama miidhamtummaa umrii guutuuf saaxiluun maatii fi hawaasa waliigalaa
          irratti ba’aa guddaa ta’a. Darbee darbee du’allee qaqqabsiisuu danda’u.
        </p>
        <p>
          Hammeenyi miidhaa sababa kufiitin dhufuu kanneen itti aanan kana fa’a:
        <ol>
          <li>Miidhaa sammuu suukaneessaa of wallaaluu qaqqabsiisuu danda’u;
          </li>
          <li>Miidhaa lafee dugdaa qaama miidhamummaa umrii guutuu qaqqabsiisuu
            danda’u;
          </li>
          <li>Qaamni cituu dabalatee qaama miidhamum- maa umrii guutuu</li>
          <li> Harkaafi miilaa cabuu;</li>
          <li>Cabaa banaa kan infeekshinaaf nama saaxilu;</li>
          <li>Miidhaa aangii guddinaa (Growth plate injury); kun yeroon yoo
            wal’aaname malee lafeen akka gooba’uu gochuu fi qaama miidhamummaa
            umrii guutuu qaqqabsiisuu danda’a;
          </li>
          <li>Miidhaa mi’a garaa fi mudhii akkasumas miidhaa naannoo laphee;</li>
          <li>Rakkoo gurraan dhagahuu fi ijaan arguu hinfayyine fida;</li>
          <li>Dhumarrattis humna olaanaan lafa dhahuun ykn iddoo ol dheeraa
            ta’erraa kufuun walqabatee duutillee quunnamuu danda’a.
          </li>
        </ol>
        </p>
      </div>
          `,
      },
      image: 3,
    },
    {
      title: `Balaa kufiitii fi rakkoolee fayyaa walxaxaa achiin booda uumaman akkamitti ittisuun danda’ama?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>Dhimmoonni fayyaan walqabatan garri caalaan akka hinuumamne dursanii
          ittisuun to’annaa baay’ee baasii qusatuudha. Armaan gaditti wanti
          agarsiisuu yaalle, mana barnootaatti ijoolleen kufuun wal qabatee
          miidhaawwan qaamaa hamaa ijoollee irra gahuu malan ittisuu fi wal’aansa
          baasii qusatu hundaaf kennuuf, hojiilee dursanii hojjetamuu qabani.</p>
        <ol>
          <li>Manneen barnootaa hanga danda’ametti oddoo mana barumsaa ‘ijoolleef
            mijaawaa’ ta’e qopheessuutu irra jira. Kana yoo jennu, gamoo hammayyaa
            ijaaruu kan gaafatu osoo hinta’in, oddoon kan ijoolleen akka
            salphaatti keessa naanna’uu danda’anii fi kan miidhaaf isaan
            hinsaaxille ta’uu qabaadha. Kana yoo goone miidhaa qaamaa meeshaalee
            iddoo oolmaa daa’imanii jiranirraa kufuun uumamu hir’isuu dandeenya.
          </li>
          <li>Mana barnootaa keessatti iddoowwan taphaa (meeshaaleen irra Koran, kan
            irraa utaalanii fi kan irraa sololaatan) wayita qophaa’anii fi yeroo
            dhaabaman, tajaajilaaf ooluu isaaniitin dura balaa kan hinfidne ta’uun
            isaanii qoratamee mirkanaa’uu qaba. Kun yoo raawwatame daa’imni
            kamiyyuu of eeggannoo dhaba kufee miidhaa qaamaaf hinsaaxilamu. Iddoo
            taphannaa sirna yeroo yeroon itti suphaman diriirsuufi ijoollee xobbeef
            immoo nama to’atu ramadamuu qaba, Ol dheerinni meeshaalee
            taphaa umrii ijoolleen kan walsimu ta’uu qaba. Meeshaalee taphaa irraa
            bakki isaan itti utaalan yookaan sololaatanille lafti isaa
            walqixxaataa, miidhaaf kan hinsaaxillee fi lallaafaa ta’uun isaa
            sakatta’amuu qaba.
          </li>
          
          <li>Manneen barnootaa baaxii manaa banaa ta’e akka hinqabaanne gorfama.
            Tarii ijoolleen iddoo sana dhaqanii tasa kufuu malu. Ijoolleen tasaa
            akka hinkufne baaxiiwwan, barandaawwaniifi sadarkaalee ittiin
            olbahanii fi gadi bu’an hirkoo akka qabaatan gorfama. Kana malees,
            ijoolleen mana barumsaa keessatti miidhaaf akka hinsaaxilamne waan
            raawwachuu qabanii fi hinqabne akka beekan karaa miinii miidiyaatin
            akkasumas barattoonni ganamaa fi galgala yeroo walgahan barsiisuun
            barbaachisaadha.
          </li>
          <li>Mana barnootaa keessatti iddoowwan bishaan qaban fakkeenyaaf,
            bo’oowwan lolaa fi boollawwan bishaanii dhabamsiisuun oddoon keessi
            hanga danda’ametti qulqulluu fi qooraa ta’uu qaba. Iddoowwan
            bishaanii banaa ta’uun baay’ee balaafamaadha. Maaliif jennaan
            ijoolleen akka kufan sababa ta’uu fi miidhaa lubbuuf yaaddessu yeroo
            kamiiyyuu uumuu waan danda’aniifi. Kanaafuu, bo’oowwanii fi boollawwan
            oddoo mana barumsaa keessa jiran kanneen qadaaduu fi iddoon
            nama mucuceessu tokkollee akka hinjiraanne gochuun baay’ee
            murtessaadha.
          </li>
          <li>Sadarkaaleen ijoolleen gamootti ittiin ol bahanii fi gadi bu’aniin miidhaaf
            kan nama hinsaaxille ta’uun isaanii mirkanaa’uu qaba. Sadarkaaleen miidhaa
            qaqqabsiisuu isaaniitin dura suphaan barbaachisu
            godhamuufillee qaba.
          </li>
          <li>Oddoo mana barumsaa keessa yeroo ijaarsi haaraan jiraatu, ijoolleen
            akka iddoo sana hingeenye dhoowwaa ta’uun isaa ifatti barreeffama
            kaa’uun ajajuu fi yoo danda’ame immoo iddoon sun daangeffamuu qaba.
            Kana malees, barataan gara iddoo dhorkaa ta’e sanaa dhaqu jiraachuu fi
            dhiisuu isaa nama yeroo yeroon hordofuu fi to’atu ramaduun
            barbaachisaadha.
          </li>
          <li>Yeroo taphni ispoortii fi sochiileen bashannanaa jiran, miidhaa qaqqabuu malu
            hir’isuuf barattoonni gitoota isaanii waliin qofa akka
            taphatan gochuun gaarii ta’a.. Iddoowwan bashannanaa lafti isaa
            walqixxaataa ta’uu qaba, Kan danda’amu yoo ta’e immoo ijoolleen yeroo
            taphatan hidhannoo miidhaa irraa ittisu fakkeenyaaf, paadota jilbaa,
            paadota ciqilee, meeshaalee angii harkaa irraa miidhaa ittisan
            akkasumas qoobii buqqee mataa irraa miidhaa ittisuu danda’u keewwachuu
            qabu.
          </li>
          <li>Ijoolleen tokko tokko fuduraalee buusuuf jechua muka koranii tasa kufuu
            danda’u. Kanneen biroo immoo gitoota isaanii waliin taphachuuf
            jecha muka koruun akkuma yeroo hedduu barame harkaa fi miilaa cabanii
            dhufuu danda’u. Kaayyoon ijoolleen muka koraniif waanuma fedhes haa
            ta’u, bakka namni to’atu fi hordofu hinjirretti akkasumas balaaf kan
            isaan hinsaaxille ta’uun isaa hanga hinmirkanaa’initti, muka koruun
            dhorkaa ta’uu qaba.
          </li>
          <li>Ijoolleen keessumaayyuu isaan xixiqqaan farda yookaan harree akka
            gulufsiisan heyyamamuufi hinqabu. Sababa kanaan yoo kufan miidhaan
            qaamaa isaanirra gahuu malu hamaa ta’uu fi du’aaf yookaan qaamaa
            miidhamummaa umrii guutuuf isaan saaxiluu akka danda’u akeekkachiisni
            kennamuufi qaba.
          </li>
          <li>Ijoolleen beekaas ta’ee osoo hinbeekin karaa fooddaa banaatin
            utaalanii qaamaa akka hinmiidhamne, fooddaawwan mana barumsaa
            hundaatti ugguraa hin hulluuqsisne tolchuun abshaalummaadha. Yeroo
            ammaa fooddaawwan mana barnootaa banamuu danda’aniif ugguraa
            hinhulluuqsisne tolchuun baramaa waan dhufeef, miidhaawwan qaamaa
            sababa kufuutin uumamu hir’isuu keessatti gahee olaanaa qaba.
          </li>
        </ol>
      </div>
          `,
      },
      image: "4Oromo",
    },
    {
      title: `Ijoollee mana barumsaa keessatti kufanii miidhamaniif, wal’aansa hoospitaala gahuun dura taasisfamuuf`,
      details: {
        html: `
        <div class="chapter-content">
        <p>Daa’imni tokko kufee erga miidhamee booda, namni naannoo sana jiru kamiiyyuu
          lubbuu daa’imichaa baraaruu qaba. Kana malees, miidhaa qaamaa biroo
          gahuu malu hir’isuufi qaamaa miidhamummaa dhaabbataan akka hinuumamne
          ittisuu qaba. Dhukkubbii hir’isuufi gargaarsa suur-yaadaa
          (xiinsammuu)kennuuf tarkaanfii fudhachuu qaba. Kun ‘gargaarsa sadarkaa
          duraa’ kan jennuun yoo ta’u, lubbuu daa’imichaa baraaruu fi dhiibbaa
          gadhee sababa miidhama qaamaa sanaan dhufuu malu ittisuuf tarkaanfii
          faayidaa guddaa qabuudha.
        </p>
        <p>
          Manneen barnootaa hundi wiirtuulee gargaarsi sadarkaa duraa itti kennamuu
          fi ogeessa leenji’e qopheessuun dhimma hunda dura xiyyeeffannaa kennuufi
          qabaniidha. Kana gochuuf meeshaalee hammayyaa guutuun hinbarbaachisu.
        </p>
        <p>Sanatti aansuun barattoota kufanii miidhaan qaamaa irra gaheef, gargaarsa
          sadarkaa duraa milkaa’aa ta’e kennuuf kanneen itti aanan kana raawwachuu
          qabu:</p>
        <ol>
          <li>Namni iddoo daa’imni sun itti kufe jiru, namoonni biroon naannoo sana
            jiran akka tumsaniif dadammaqsuufi daa’imichaaf wal’aansa danda’amu
            kennuuf, iyya na dhaqqabaa dhageesisuu qaba. Iyya dhageesisaa daa’imicha
            wanta argateen gargaaruuf yaalii gochuu qaba. Asirratti
            namni gargaarsa wal’aansaa sadarkaa duraatin leenji’e yoo jiraate,
            battalatti waamamee daqiiqaawwan muraasa keessatti tarkaanfiiwwan
            lubbuu baraarsan jechuunis daa’imicha akkaataa barbaachisuun ciibsuu,
            ujummoon argansuu haala sirrii ta’een hojjechuu isaa mirkaneessuu,
            sirna argansuu ilaaluu fi haalota lubbuuf yaaddessaa ta’an kamiiyyuu
            sakatta’uu fi sirrreessuu qaba.
          </li>
          <li>Haalonni lubbuuf yaaddessan akka hinjirre erga mirkaneessinee booda,
            ittii aansee immoo kutaalee qaamaa hunda sakatta’uu qabna. Yeroo kana
            raawwannu daa’imicha/daa’imatti lafa walqixxaataa, yoo arganne immoo
            boordii lafee dugdaa ol utubee qabu irra ciibsuu fi kutaan qaamaa
            miidhame yookaan iddoon garmalee dhukkubu eessa akka ta’e gaafachuu
            qabna. Miidhaan daa’imichi/daa’imattiin hinhimatin kan dhokate
            jiraachuu isaa adda baasuuf mataadhaa hanga qeensa miilaatti qorachuun
            barbaachisaadha.
          </li>
          <li>Miidhamni lafee fi walqaba qaamaa (musculoskeletal injury); cabiinsi
            harkaa fi miilaa jiraachuu fi dhiisuu isaa raajii osoo hinka’in
            qorannoo qofaan beekuuf, namni qoratu sun ‘mallattoolee cabiinsaa
            mamii hinqabne’ jedhamee kan beekamu fayyadamuu kan danda’u yommuu
            ta’u, kunis bu’aalee qorannoo itti aanan kana of keessaa qabaata
            <ol type="a">
            <li>Kutaa qaamaa miidhame sanarraa dhukkubbii cimaa itti dhagayamu,</li>
            <li>Harka yookaan miila miidhaan irra hin gahiin wajjiin walbira
            qabamee yoo ilaalamu, jal’inaa fi gabaabbina qaamaa ifatti
            mul’atu,</li>
            <li>Cabaa (banaa) alaa mul’atu,</li>
            <li>Qaamni miidhame sun yeroo socho’u sagalee dhagayamu yookaan yeroo
            harkaan qaqqaban kan beekamu (Ta’us sagalee dhagayuuf jecha wawarraaqsuun, miidhaa ujummoo dhiigaa fi narvii
            waan qaqqabsiisuuf,
            kun gonkuma yaalamuu hinqabu),</li>
            <li>Sochii ykn wawarraaqqii sirrii hintaane kan qaama miidhame sanarra
            jiru fa’a. Daa’imni sun kanneen olitti ibsaman keessaa tokkollee
            yoo qabaate/qabaatte, gargaarsa wal’aansaa sadarkaa duraa hunda
            kennuu fi battalumatti gara iddoo wal’aansa lafee fi walqaba
            qaamaa barbaachisu argachuu danda’uttti/dandeessutti ergamuu
            qaba/qabdi.</li>
            </ol>
          </li>
          <li>Iddoon miidhame adda bahee erga beekamee booda, cabaan yookaan immoo
            miidhamni gogaa fi irree jiraachuu mala shakkiin jedhu yoo jiraate,
            mana barumsichaati namni dhimmichi ilaallatu maatii daa’imichaa/daa’imattii deemee yookaan bilbilee dubbisuu
            qaba. Kana gidduutti
            kutaan qaamaa miidhame akka hinsochoone wayiin utubanii tursiisuun
            barbaachisaadha. Harkaa fi miila miidhame (limb injury) yeroodhaaf
            utubanii tursuuf, wanta oddoo mana barumsaa keessaa arganne kamiiyyuu jechuunis yuuniifoormii
            daa’imichaa/daa’imattii, kaartoonii fi
            huccuu gosa kamiiyyuu fayyadamuu dandeenya.
          </li>
        </ol>
        </p>
      </div>
          `,
      },
      image: 5,
    },
    {
      title: `Ijoollee kufanii miidhamaniif yeroo gargaarsa sadarkaa duraa kennitan maal gochuu qabdu?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>Daa’imni tokko yeroo kufee miidhamu kutaan qaamaa miidhame sun akka
          hinsochonetti utubanii tursiisuuf, hojiileen raawwatamuu qaban
          tartiibaan armaan gaditti dhiyaataniiru:-
        </p>
        <ol type="a">
          <li>Iddoon dhiigu kamiiyyuu yoo jiraate, fooxaa kiitii gargaarsa
            sadarkaa duraa keessa jiruun dhiigicha dhaabuu yaalaa. Kiiticha
            keessa huccuun hoomtuu hinjiru yoo ta’e, uffata
            daa’imichaa/daa’imattii yookaan yuuniifoormii isaa/ ishee
            fayyadamuu dandeessu. Asirratti infeekshinaa caala dhiigicha
            dhaabuun gargaarsi dursi kennamuuf qabu waan ta’eef, huccuu argame
            fayyadamuun dhiigicha dhaabuun barbaachisaadha. Yeroo fooxaa
            fayyadamtan dadachaasuu fi xiqqoodhuma shab godhanii qabsiisuudha
            malee, kutaa qaamaa miidhame sanatti hinmarinaa. Yoo itti martan,
            qaama dhiigaa jiru sana hudhee qabuun, dhiiga kutaa qaamaa iddoo
            miidhame sanaa gadii jiru keessa naanna’u waan addaan kutuun
            miidhaa hamaaf waan saaxiluuf of eeggannoo godhaa. Dhiigicha
            dhaabuuf yeroo tattaafattan, mataan keessan dhiigaan akka
            hinfaalamne, tarkaanfiiwwan ofeeggannoo barbaachisaa ta’an
            hordofaa.
          </li>
          <li>Hanga danda’ametti huccuu yookaan uffata qaama
            daa’imichaa/daa’imattii miidhame gubbaa jiru hunda irraa kaasaa.
          </li>
          <li>Lafeen dugdaa miidhamuu mala shakkiin jedhu yoo jiraate,
            daa’imichi yoo hoospitaala hinseeniniifi miidhaa akkasii akka
            hinqabne hanga hinmirkanaa’initti, bakkaa osoo hinsocho’in iddoo
            jirutti deeggarsi godhamuufi qaba. Yoo bakkaa sochooftan yookan
            yoo garagalchitan, dabalataan miidhama narvii qaqqabsiisuu danda’a
            waan ta’eef, ofeeggannoo gochuutu isinirra jira.
          </li>
          <li>Jal’inni qaamaa (deformity) ifatti mul’atu yoo jiraate malee,
            kutaa qaamaa miidhame sana haala teessuma isaa jijjiiruu ykn
            sirreessuu yaaluu hinqabdan. Maaliif jennaan miidhaa biraa fiduu
            fi daa’imichatti/daa’imattiitti garmalee dhukkubbii hammeessuu
            danda’a waan ta’eefi. Kanaafuu, iddoodhuma jirutti utubdanii yoo
            tursiistan gaariidha. Tarii balaa sanaan narvii fi naanna’iinsi
            dhiigaa miidhamee jira yoo ta’e jechuunis qaamni iddoo miidhame
            sanaa gadi jiru homaa hinwarraaqu yoo ta’e, yeroo tuttuqan kan
            itti hindhagayamne yoo ta’ee fi naanna’iinsi dhiigaa yoo gufate,
            kutaa qaamaa miidhame sana baay’ee osoo hinsosochoosin, haala
            teessuma isaa xiqqoo sirreessuun, dalagaan narviifi naanna’iinsi
            dhiigaa akka sirraa’u gochuu dandeessu.
          </li>

          <li>Qaama miidhame iddoodhuma jirutti utubdanii tursiisuu wayita
            yaalii gootan, namni isin cinaa jiru qaamichi bakkaa akka
            hinsochoone gochuun akka isin gargaaru godhaa.
          </li>

          <li>Yeroo waan utubu qaama miidhame jala keessan, iddoo walqaba qaamaa
            iddoo sanaa olii fi gajjallaan jiran yookaan lafeen iddoo
            miidhame cinaa jiru akka hinwarraaqne yaalii godhaa.
          </li>

          <li>Qaama miidhame sana yeroo hiitan wanta itti martan hinjabeessinaa
            yookaan immoo jabeessitanii itti hinmarinaa. Yoo jabaate dhiiga
            naanna’u irratti dhiib- baa dabalataa uuma.
          </li>

          <li>Wanta qaama miidhame utubu yeroo keessan jilbi digirii 10-15 akka
            dacha’u godhaa; ciqileefi ijoon miilaa immoo digirii 90 haa ta’u
            akkasumas mudhii fi aangiin harkaa immoo haa diriiru.
          </li>
          <li>Wanta utubu yeroo keessan osoo hinjabeessin itti maruun yookaan
            qaama miidhametti hidhuun abdachiisaa akka ta’u godhaa.
            Abdachiisaa akka ta’u gochuuf huccuu ykn uffata iddoo sanaa
            kaastan fayyadamuu dandeessu.
          </li>
          <li>Sana booda daa’imichi/daa’imattin gara dhaabbata fayyaa dhiyoo
            jirutti akka ergamu/ergamtu haala mijeessuu isin brabaachisa.
          </li>
          <li>Ogguu daa’imichi/daa’imattiin gara dhaabbata fayyaatti
            ergamu/ergamtu, namni yeroo inni kufu /isheen kuftu argee ture
            yookaan namni gargaarsa wal’aansaa sadarkaa duraa kenneef osoo
            walin deemee ogeessa dhaabbata fayyaa sanatti tajaaji;a
            wal’aansaa kennutti waa’ee gargaarsa wal’aansaa sadarkaa duraa
            kennameef ibseefi daa’imicha/daa’imatti itti kennee gaarii ta’a.
          </li>
        </ol>
      </div>
          `,
      },
      image: 6,
    },
    {
      title: `Ijoollee kufanii miidhamaniif yeroo gargaarsa wal’aansaa sadarkaa duraa kennitan wanti isin gochuu hinqabne maali?`,
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>Daa’imni tokko kufuu isaatin/isheetin miidhaa qaamaa irra gahe
            akka waan salphaatti hin ilaalinaa. Ijoolleen iddoo ol dheeraa
            ta’erraa kufan hundi, miidhaan sochii ispoortii keessa
            qaqqabe, miidhaan qaamaa humna olaanaan yoo qaqqabee fi iddoon
            miidhame sun akka malee dhukkubee aaduun yoo jiraate, miidhaan
            sun akka waan salphaatti ilaalamuu hinqabu. Daa’imichi
            kufee/tee erga miidhamee/tee booda kan bobboo’u yoo ta’e, gara
            manaatti ergamuu hinqabu. Lafeen ijoollee uumamni isaa kan
            gaheessotaan adda waan ta’eef,
         <ol type="a">
            <li>Miidhaa aangii guddinaa ijoolleef (growth plate injury),</li>
            <li>Cabiinsa lafee cinaa tokkoon uumamuuf (greenstick
            fracture),</li>
            <li>Baqaqa lafee gar-tokkeen uumamuuf (torus fracture)</li>
            <li>Jal’ina lafeef (plastic deformity) saaxilamuuf carraan
            qaban olaanaadha. Kanaafuu, haalli miidhaa sanaa hakiima
            ispeeshaalistii lafee fi walqaba qaamaa baqaqsee hodhuun
            wal’aanuun qoratamee hanga murtii argatutti, daa’imni sun
            akka cabetti/cabdetti ilaalamuu qaba/qabdi.</li>
            </ol>
          </li>
          <li>Kutaa qaamaa miidhame sukkuumuun, warraaqsuu fi daa’ima sana
            ogeessa aadaa lafee deebisu bira geessuun gonkuma sirrii miti.
            Ijoolleen kufanii qaamaa miidhaman hundi hakiima
            ispeeshaalistii wal’aansa lafee fi walqaba qaamaa ogummaa isaa
            barateen qoratamuu qabu. Ijoolleen rakkoolee walxaxaa kanneen
            akka gaangiriinii, jal’ina qamaa, miidhaa hidda dhiigaa fi kan
            kana fakkaataniif saaxilamoodha. Kana malees, qaamni ijoollee
            ogguu cabu raajii (X-ray) ka’ee ogeeyyii wal’aansaa barataniin
            yoo qoratame malee, akaakuun cabaa maal akka ta’e beekuu fi
            adda baasuun rakkisaadha. Kutaa qaama ijoollee cabe sukkuumuun
            yookaan immoo bakkaa warraaqsuu yaaluun, gocha dhukkubbii
            hamaa fiduudha. Ijoolleen yeroo qaamni isaanii miidhame
            sukkuumamu, dhukkubbii itti dhagayamurraa kan ka’e of
            wallaaluu waan danda’aniif, gocha akkasii lagachuun
            barbaachisaadha.
          </li>
          <li>Qaama miidhame jabeessitanii huccuu itti hinmarinaa. Kutaa
            qaamaa (harkaa fi miila) yeroo huccuu jabeessitanii itti
            martan, dhiigni akka hinnaannofne irra caalaa ittisuun gara
            gaangiriinitti geeddarama. Kanaafuu, wanti nuti qaama
            miidhame utubuuf fayyadamnu hundi, hanga danda’ametti kan
            itti maramee hidhamu ta’uu hinqabu. Qaama sana utubee akka
            qabutti qofa laafee shab godhamuu qaba.
          </li>

          <li>Dhiiga dhiigu dhaabuuf waan itti maramu (tourniquet) hin
            fayyadaminaa. Dhiiga dhiigu dhaabuuf qaama miidhametti
            huccuu maruun, dhiiga naanna’u gufachiisa. Kanaafuu, dhiiga
            dhaabuuf huccuu yabbisuun itti uwwisaa; wanta harka yookaan
            miila miidhame sana ol qabu qofa fayyadamaa. Sana booda,
            daa’ima miidhame sana dafaa gara dhaabbata fayyaatti ergaa.
          </li>
        </ol>
      </div>
          `,
      },
      image:7,
    },
    {
      title: `Ijoollee kufanii miidhaman eenyutu, yoom, akkamitti gara dhaabbata fayyaatti erga?`,
      details: {
        html: `
        <div class="chapter-content">

        <p>Ijoolleen kufanii qaama miidhaman, kanneen itti aanaan kana keessaa tokko
          yoo isaan muudate battalatti gara dhaabbata fayyaatti ergamuu qabu:</p>
        <ol type="1">
          <li>Miidhaa irra gaheen walqabatee madaan dhiigu kamiiyyuu yoo jiraate;</li>
          <li>“Mallattoon cabuu hin mamsiisne” kanneen olitti ibsaman yoo jiraatan;</li>
          <li>Kutaan qaamaa ta’e tokko miidhamuu akka hinoolle yoo shakkii qabaattan;</li>
          <li>Kutaan qaamaa miidhame dhukkubbii yoo qabaatee fi dhiita’e;</li>
          <li>Harka yookaan miila miidhame fayyadamuuf yookaan sochoosuuf yoo
            rakkisaa ta’e;</li>
          <li>Ijoollee xixiqqaa yoo ta’an, miidhaan erga irra gaheen booda akka
            malee boo’u yoo ta’e.
          </li>
        </ol>
        <p>
          Ijoolleen kufanii qaamaa miidhaman yeroo itti riifar godhaman ilaalchisee,
          iddoo miidhaan sun itti qaqqabetti gargaarsi wal’aansaa sadarkaa duraa
          kennameef yeroo murtaa’eef hordoffiin taasifamaaf. Sana booda, miidhaan
          irra gahe salphaa waan hinta’iniif, daa’imichi gara barnootatti yookaan
          tapha isaatti deebi’uu yoo hindandeenye, battalumatti gara dhaabbata
          fayyaa dhiyeenya jirutti riifar gochuutu isinirra jira. Ijoolleen sun erga
          miidhaan irra gaheen booda riifar godhamanii, hammeenyi miidhaa sanaa
          qoratamee wal’aansi barbaachisu godhamaaf. Kanaafuu, ijoolleen kufanii
          qaamaa miidhaman akka isin harka hinturre godhaa.
        </p>
        <p>
          Ijoollee kufanii miidhaman akkamitti akka riifar godhaman ilaalchisee,
          jalqaba lubbuu daa’imichaa baraaruu fi kutaa qaamaa miidhame fayyisuuf,
          gargaarsi wal’aansaa sadarkaa duraa kennuufin danda’amu hundi mana
          barumsaa keessanitti kennamuufi qaba. Itti aansuun immoo maatiin
          daa’imichaa haala jiru akka beekaan itti himamee, daa’imichi maatii
          yookaan guddistuu wajjiin gara dhaabbata fayyaatti geessamuu qaba.
          Daa’imicha dhaabbata fayyaatti kennuuf bakka bu’aan mana barumsichaa tokko
          waliin deemuu qaba.
        </p>
      </div>
          `,
      },
      image: "8Oromo",
    },
    {
      title: `Hojileen wal’aansa miidhama qaamaa murteessaa ta’an maal fa’a?`,
      details: {
        html: `
        
        <div class="chapter-content">
        <p>Daa’imni kufee miidhame yeroo nama qunnamu, gargaarsi wal’aansaa sadarkaa 
          duraa barbaachisu bakkuma miidhaan sun qaqqabetti akkuma namoota biroo
          miidhama qaamaaf saaxilaman kamiif taasifamutti kennamuufi jalqabuu qaba.
          Itti aansuun immoo gara dhaabbata fayyaatti darbanii wal’aansonni idilee
          hundi kennamuufi qabu. Isaanis hojiilee gurguddoo itti aanan kanneen fa’a:</p>
        <ol type="1">
          <li>Miidhaan lubbuu daa’imichaaf yaaddessu jiraachuun isaa qoratamee,
            akkaatuma sanaan qabiinsi taasifamaaf. Tooftaan wal’aansaa nama qaamaa 
            miidhame kamiifiyyuu taasifamu qajeelfamoota ‘ lubbu baraarsa
            balaawwan cimaa qindaa’e’ jedhu kan hordofu ta’a.
          </li>
          <li>Itti aansuun gosa miidhichaa irratti hundaa’uun, wal’aansi adda addaa 
            jechuunis qorichi dhukkuba namatti fursiisu, qorichi infeekshinaa,
            qorichi tiitaanesii fi wal’aansi dhibee hurgufsiisuu (qorichi dhukkuba
            gaggabsaa kennamu) akkaatuma bu’aa qorannootin ni kennama.
          </li>
          <li>Madaan jira yoo ta’e, dhiiguu akka dhaabu erga gooneen booda, qulqullaa’ee 
            huccuu wantoota faalama uumuu danda’anirraa bilisa ta’een marama.
          </li>
          <li>Jal’inni qaamni miidhamee kan ifatti mul’atu fi buqqa’insi walqaba 
            qaamaa yeroo muudatu, daa’imichaaf qorichi dhukkubbii itti fursiisu erga
            kennameefi booda, kan sirreefamu yookaan bakka isaatti kan deebi’u
            ta’a. Daa’ima rakkoon akkasii muudateef, qorichi homaatuu osoo hinkennamin 
            sirreessuu yaaluun gonkuma dhorkamaadha. Kunis rakkoo caalaaf
            kan saaxilu waan ta’eef, iddoo miidhaan sun qaqqabettis ta’ee,
            dhaabbata fayyaatti osoo qorichi hinkennaminiif wanti akkasii yaalamu
            hinqabu.
          </li>
          <li>Kutaa qaamaa miidhame sanaaf qajeeltoowwan wal’aansaa barbaachisaa
            ta’an hordofuun wanti qaama deeggaree qabu ni tolfamaaf.
          </li>
          <li>Itti aansuun daa’imni wal’aanamaa jiru qorannoo raajiif (X-ray) ergama. 
            Asirratti dhimmi murteessaan isin beekuu qabdan, miidhaan cabuu
            ijoollee muudatu kan gaheessotaan baay’ee adda ta’uu isaa fi cabaa
            sana qorachuuf raajiin kaasnus adda akka ta’e akkasumas waa’ee
            rakkinichaa ibsa kennuufillee qorannoo of eeggannoo cimaan raawwatamu 
            kan barbaadu ta’uu isaati. Kanaafuu, namni raajii (X-ray) ilaaluu
            danda’u kamiiyyuu, bu’aa qorannoo daa’imman caban hundaa akka
            salphaatti beekuu hindanda’u. Kana beekuu fi of eeggannoon adda baasuuf 
            dame wal’aansaa kanaan ogeessa ta’uu gaafata. Waan kana ta’eef
            ogeessonni ganda keessaa osoo damee kanaan hin leenjiin raajii
            ajajanii fi waan hinbeekne kan dubbisan fakkaatanii qaama ijoollee miidhame
            irra deddeebi’anii sukkuumuu fi jabeessanii hidhuun rakkoo hintaaneef
            saaxilan waan baay’ataniif maatiin wal’aansi ijoollee isaaniif kennamu
            ogeessa wal’aansaa leenji’een ta’uu isaa mirkaneessuuf itti gaafatamummaa fi dirqama qabu.
          </li>
          <li>Qorannoo waliigalaa fi bu’aa raajii (eksi reyii) irratti hundaa’uun
            wal’aansa murteessaa daa’imichaaf barbaachisu ilaalchisee maatii
            yookaan guddistuu wajjiin filannoowwan wal’aansaa jiranirratti mariin
            ni taasifama. Achiin booda wal’aansi dhumaa ogeessa dhimmi ilaallatuun kan kennamu ta’a.
          </li>
          <li>Walumaagalatti, miidhaawwan qaamaa ijoollee muudatan tooftaa baqaqsanii 
            hodhuu malee wal’aanamuu kan danda’aniidha. Kana akkaataa
            barbaachisuun hojiirra oolchuufis ta’ee bu’aan isaallee gaarii akka
            ta’u, ogeessa wal’aansaa ogumichaan leenji’e barbaada. Itti
            dhiyeenyaan hordofunillee akkasuma dhimma murteessaadha. Ijoollee
            kufanii miidhamaniif kaayyoon wal’aansa sirrii kennuun
            barbaachisuuf, rakkinicha yeroon adda baasuufi wal’aanuuf, dafanii
            wayyaa’anii barnoota isaanitti ariitin deebi’uu akka danda’aniifi.
            Hojiilee arman olitti ibsine hunda akkaataa barbaachisuun
            raawwachuudhaan, rakkoolee barnoota addaan kutuu fi mana barnootaati
            hafuu, ijoollee kufanii balaan quunname biratti mul’atan qabatamaan hir’isuun ni danda’ama.
          </li>
        </ol>
      </div>
      `,
      },
      image:9,
    },
    {
      title: `Wabiiwwan`,
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>World Health Organization (WHO).Injuries and Inequities-Guidance forAddressing Inequities in
            unintention-al Injuries. Copenhagen, Denmark:World Health Organization RegionalOfﬁce for Europe; 2014</li>
          
          <li>CDC, Injuries among Children andTeens report, https://www.cdc.gov/injury/features/child-injury/index.html
          </li>
          <li>Chapman RL, Buckley L, SheehanM, Shochet IM. Pilot evaluation ofan adolescent risk and injury pre-vention
            programme incorporatingcurriculum and school connected-ness components. Health Educ Res.2013;28(4):612–625
          </li>
          <li>James S.L, Lucchesi L.R, BisignanoC, Castle C.D, Dingels Z.V, et al.The global burden of falls: Global,
            re-gional and national estimates of mor-bidity and mortality from the GlobalBurden of Disease Study 2017.
            InjuryPrev. 2020, 26 (Suppl. 1), i3–i11</li>
          <li>Amy E Peden, Richard C Franklin,Child Injury Prevention: Is it time toaddress the determinants of
            Health.Children, 2021, 8:46.</li>
          <li>International Federation of Red crossand Red crescent Societies, Interna-tional First aid and
            Rescessitationguidelines, 2016</li>
          <li>Meghalaya State Disaster Man-agement Authority, Basic First AidManual, India, 2014</li>
          <li>Blake G, Velikonja D, Pepper V,Jilderda I, Georgiou G. Evaluating an in-school injury
            preventionprogramme’s effect on children’shelmet wearing habits. Brain Inj.2008;22(6):501–507</li>
          <li>Pickett, W.; Molcho, M.; Simpson,K.; Janssen, I.; Kuntsche, E.; Ma-zur, J.; Harel, Y.; Boyce, W.F.
            Crossnational study of injury and socialdeterminants in adolescents. InjuryPrev. 2005, 11, 213–218</li>
          <li>Lama Bou-Karroum, Fadi El-Jardali,Mathilda Jabbour, Aya Harb, RachaFadlallah, et al, Preventing
            Unin-tentional Injuries in School-AgedChildren: A Systematic Review.Paediatrics, 2022, 149:6</li>
          <li>UNICEF. Levels & Trends in ChildMortality Report 2019. New York,NY: UNICEF; 2020</li>
          <li>Jamison DT, Breman JG, MeashamAR, et al. Disease Control Prioritiesin Developing Countries. Washing-ton,
            DC: The World Bank; 2006</li>
          <li>Barcelos RS, Del-Ponte B, SantosIS. Interventions to reduce accidentsin childhood: a systematic review.
            JPediatr (Rio J). 2018;94(4):351–367</li>
          <li>Mytton J, Towner E, Brussoni M,Gray S. Unintentional injuries inschool-aged children and
            adolescents:lessons from a systematic review ofcohort studies. Inj Prev.2009;15(2):111–124</li>
          <li>Mock CN, Smith KR, Kobusingye O,et al. Injury Prevention and Environ-mental Health: Key Messages. 3rded.
            Disease Control Priorities. Vol 7.Washington, DC: The World Bank;2017</li>
          <li>Nauta J, van Mechelen W, OttenRHJ, Verhagen EALM. A system-atic review on the effectivenessof school and
            community-basedinjury prevention programmes onrisk behaviour and injury risk in 8-12year old children. J Sci
            Med Sport.2014;17(2):165–172</li>
          <li>Kendrick D, Mulvaney CA, YeL, Stevens T, Mytton JA, Stew-art-Brown S. Parenting interventionsfor the
            prevention of unintentionalinjuries in childhood. Cochrane Data-base Syst Rev. 2013;(3)</li>
          <li>Towner E, Dowswell T, Jarvis S.Updating the evidence. A systematicreview of what works in
            preventingchildhood unintentional injuries: part1. Inj Prev. 2001;7(2):161–164</li>
          <li>Kendrick D, Young B, Mason-JonesAJ, et al. Home safety education andprovision of safety equipment
            forinjury prevention. Cochrane DatabaseSyst Rev. 2012;(9)</li>
          <li>Pearson M, Garside R, Moxham T,Anderson R. Preventing unintentionalinjuries to children in the home:
            asystematic review of the effective-ness of programmes supplying and/or installing home safety
            equipment.Health Promot Int. 2011;26(3):376–392</li>
          <li>Pearson M, Hunt H, Garside R, Mox-ham T, Peters J, Anderson R. Prevent-ing unintentional injuries to
            children under 15 years in the outdoors: asystematic review of the effectivenessof educational programs. Inj
            Prev.2012; 18(2):113–123</li>
          <li>Orton E, Whitehead J, Mhizha-Mu-rira J, et al. School-based educationprogrammes for the prevention
            ofunintentional injuries in children andyoung people. Cochrane DatabaseSyst Rev. 2016;(12):CD010246</li>
          <li>Morrongiello BA, Lasenby-LessardJ. Psychological determinants of risktaking by children: an
            integrativemodel and implications for interven-tions. Inj Prev. 2007;13(1):20–25</li>
          <li>DelCastillo-Andres O, Toronjo-Hor-nillo L, Toronjo-Urquiza L. Effectsof fall training program on
            autom-atization of safe motor responsesduring backwards falls in school-agechildren. Int J Environ Res
            PublicHealth. 2019;16(21)</li>
          <li>WHO, Falls, Key facts, 2021, https://www.who.int/news-room/fact-sheets/detail/falls</li>
        </ol>
      </div>
      `,
      },
    },
  ];
  return result;
};
